export default __webpack_public_path__ + "static/media/cssc.0fdaa4ec.png";